module.exports = __webpack_public_path__ + "img/Weapon_248.bca8a142.png";